module.exports = __webpack_public_path__ + "static/media/item-3.2f1b4554.png";